@if (hasSeoContent()) {
	<div class="seo-content-container hmf-mt-s hmf-px-s">
		<h2 class="hmf-header-bold-s hmf-mb-m">{{seoHeader()}}</h2>
		@for (seoTabContent of seoTabContentList(); track trackByHeader($index, seoTabContent.header)) {
			<shared-component-filter-accordion
				[header]="seoTabContent.header | titlecase"
				[isInline]="true"
				[isExpanded]="true"
				[topBorder]="$first"
				[bottomBorder]="!(hasFeaturedLinks() && $last)"
				data-testid="seo-tab-content">
				<div ngProjectAs="customAccordionContent">
					<div class="hmf-pl-m hmf-mr-s hmf-pb-s tab-content hmf-body-m" [innerHTML]="seoTabContent.content"></div>
				</div>
			</shared-component-filter-accordion>
		}
		@if (hasFeaturedLinks()) {
			<shared-component-filter-accordion
				[header]="'featured categories' | titlecase"
				[isInline]="true"
				[isExpanded]="true"
				data-testid="featured-categories">
				<div class="featured-category-container tab-content" ngProjectAs="customAccordionContent">
					<ul>
						@for (featureLink of featuredLinks(); track trackByKey($index, featureLink.key)) {
							<li class="hmf-mr-xxs">
								<a hmf-text-link variant="secondary" [linkURL]="featureLink.value">
									{{featureLink.key}}
								</a>
							</li>
						}
					</ul>
				</div>
			</shared-component-filter-accordion>
		}
	</div>
}
